<div id="googlepay-container" ref="googlePayContainer"></div>
